import React from 'react';
import { motion } from 'framer-motion';
import DotBackground from './DotBackground';

const principles = [
  {
    icon: "🛡️",
    title: "Format Validity",
    description: "Receive realistic synthetic datasets exactly in your desired format, ensuring your models train effectively and painless, no ETL, directly as you need it."
  },
  {
    icon: "📊",
    title: "Edge Case Coverage",
    description: "Access rare and difficult scenarios that would be challenging or unsafe to reproduce in real-world testing. For safety-critical applications, synthetic datasets should be used only as experimental data or supplementary training material to enhance real-world data collection."
  },
  {
    icon: "📋",
    title: "Data Labeling",
    description: "Every dataset you receive comes with complete labeling, enabling supervised learning without the need for manual annotation. Set your own labels or allow AI to generate them."
  },
  {
    icon: "⚙️",
    title: "Customizable Variables",
    description: "Control environmental conditions, sensor characteristics, and scenario parameters to get data tailored for your specific use cases."
  },
  {
    icon: "🔒",
    title: "Privacy Compliance",
    description: "Eliminate privacy concerns associated with real user data, helping you stay compliant with regulations."
  },
  {
    icon: "⚡",
    title: "Rapid Iteration",
    description: "Get new datasets in minutes rather than spending weeks or months collecting real-world data for each iteration."
  }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const Principles = () => {
  return (
    <section id="principles" className="section relative overflow-hidden bg-background">
      <DotBackground />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Synthetic Dataset Principles</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Your realistic, comprehensive datasets are built on these core principles
          </p>
        </motion.div>
        
        <motion.div 
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {principles.map((principle, index) => (
            <motion.div 
              key={index} 
              className="card"
              variants={item}
            >
              <h3 className="text-xl font-bold mb-4 text-white">{principle.title}</h3>
              <p className="text-foreground-secondary">
                {principle.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Principles;
